/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Event_Trigger_Filter_Duplicate_KeyInputs */



/**
* | output |
* | --- |
* | "Each field can appear only once." |
*
* @param {Agent_Event_Trigger_Filter_Duplicate_KeyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_event_trigger_filter_duplicate_key = /** @type {((inputs?: Agent_Event_Trigger_Filter_Duplicate_KeyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Event_Trigger_Filter_Duplicate_KeyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Jedes Feld darf nur einmal vorkommen.")
	return /** @type {LocalizedString} */ ("Each field can appear only once.")
});